import barba from '@barba/core';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.beforeOnce((data) => {
            this.heroSlider()
            this.notfoundSlider()
            this.philosophySlider01()
            this.philosophySlider02()
            this.freeModeSlider()
            this.itemSlider()
            // this.blogSlider()
            // this.pickupSlider()
            // this.eventSlider()

        })
        barba.hooks.after((data) => {
            this.heroSlider()
            this.notfoundSlider()
            this.philosophySlider01()
            this.philosophySlider02()
            this.freeModeSlider()
            this.itemSlider()
            // this.blogSlider()
            // this.pickupSlider()
            // this.eventSlider()
        });
        
    }
    
    heroSlider() {
        const heroSlider = document.getElementById('hero--slide');
        if(heroSlider){
            const target = '#hero--slide.splide';
            const target_options = {
                type: 'fade',
                rewind: true,
                autoplay: true,
                arrows: false,
                drag: false,
                interval: 8500,
                speed: 5000,
                pauseOnHover: false,
            }
            
            const mySplide = new Splide(target, target_options);
            mySplide.mount();
        }
    }
    notfoundSlider() {
        const notfoundSlider = document.getElementById('p-404__slide');
        if(notfoundSlider){
            const target = '#p-404__slide.splide';
            const target_options = {
                type: 'fade',
                rewind: true,
                autoplay: true,
                arrows: false,
                drag: false,
                interval: 8000,
                speed: 4500,
                pauseOnHover: false,
            }
            
            const mySplide = new Splide(target, target_options);
            mySplide.mount();
        }
    }
    
    philosophySlider01() {
        const philosophySlider01 = document.getElementById('philosophy--slide01');
        if(philosophySlider01){
            const target = '#philosophy--slide01.splide';
            const target_options = {
                type   : 'loop',
                arrows: false,
                pagination: false,
                drag: false,
                breakpoints: {
                    575: {
                        drag: true,
                    },
                },
                autoWidth: true,
                autoScroll: {
                    speed: 0.3,
                    pauseOnHover: false,
                },
            }
            
            const mySplide = new Splide(target, target_options);
            mySplide.mount({ AutoScroll });
        }
    }

    philosophySlider02() {
        const philosophySlider02 = document.getElementById('philosophy--slide02');
        if(philosophySlider02){
            const target = '#philosophy--slide02.splide';
            const target_options = {
                type   : 'loop',
                arrows: false,
                pagination: false,
                drag: false,
                gap: 25,
                breakpoints: {
                    575: {
                        drag: true,
                    },
                },
                autoWidth: true,
                autoScroll: {
                    speed: 0.3,
                    pauseOnHover: false,
                },
            }
            
            const mySplide = new Splide(target, target_options);
            mySplide.mount({ AutoScroll });
        }
    }
    
    freeModeSlider() {
        new Swiper ('.freemode--slider',{
            slidesPerView: 1.1,
            freeMode: true,
            // scrollbar: {
            //     el: ".freemode--slider .progress--bar",
            //     draggable: true,
            // },
            spaceBetween: 20,
            breakpoints: {
                576: {
                    slidesPerView: 1.8,
                },
                768: {
                    slidesPerView: 2.2,
                },
                992: {
                    slidesPerView: 2.4,
                },
                1200: {
                    slidesPerView: 2.8,
                },
                1399: {
                    slidesPerView: 3.2,
                },
                1599: {
                    slidesPerView: 3.9,
                    spaceBetween: 40,
                },
            }
        })
    }

    itemSlider() {
        const itemSlider = document.querySelector('.p-items__single--slider');
        if (itemSlider) {
            const target = '.p-items__single--slider .splide';
            const target_options = {
                rewind: true,
                arrows: false,
                perMove: 1,
                pagination: false,
                autoplay: true,
                interval: 6000,
                speed:1500,
                //gap: '40px',
                drag: true,
                pauseOnHover: false
            }
    
            const mySplide = new Splide(target, target_options);
    
            const thumbnails = document.getElementsByClassName('thumbnail');
            let current = 0;
    
            for (let i = 0; i < thumbnails.length; i++) {
                initThumbnail(thumbnails[i], i, mySplide); // mySplideを引数として渡す
            }
    
            mySplide.on('mounted move', function () {
                const thumbnail = thumbnails[mySplide.index];
    
                if (thumbnail) {
                    if (current) {
                        current.classList.remove('is-active');
                    }
    
                    thumbnail.classList.add('is-active');
                    current = thumbnail;
                }
            });
    
            mySplide.mount();
        }
        function initThumbnail(thumbnail, index, mySplide) {
            thumbnail.addEventListener('click', function () {
                mySplide.go(index); // 引数として受け取ったsliderを使用する
            });
        }
    }

    blogSlider(){
        // const blog_thumbnails = document.querySelectorAll('.blog-slider-thumbnails a');
        // const blogSlider = new Swiper('.js-blog__slider', {
        //     loop: true,
        //     speed:400,
        //     easing:"linear",
        //     loopAdditionalSlides : 5,
        //     slidesPerView: 'auto',
        //     spaceBetween: 20,
        //     simulateTouch:true,
        //     centeredSlides: false,
        //     breakpoints: {
                
        //         576: {
        //             slidesPerView: 'auto',
        //             spaceBetween:  40,
        //         }
        //     }
        // });
        
        // const blogThumbnailAddEvent = (el,i) => {
        //     el.addEventListener('click',function(e){
        //         e.preventDefault();
        //         blogSlider.slideTo(i+1);
        //     })
        // }

        // for(var i = 0; i <  blog_thumbnails.length; i++){
        //     blogThumbnailAddEvent( blog_thumbnails[i],i);
        // }
    }
    pickupSlider(){
        // const pickup = new Swiper('.js-pickup--slider', {
        //     loop: true,
        //     speed:400,
        //     easing:"linear",
        //     loopAdditionalSlides : 5,
        //     slidesPerView: 'auto',
        //     spaceBetween: 20,
        //     simulateTouch:true,
        //     centeredSlides: false,
        //     breakpoints: {
                
        //         576: {
        //             slidesPerView: 'auto',
        //             spaceBetween:  40,
        //         }
        //     }
        // })
    }
    eventSlider(){
        // const SliderContentClass = '.js-event__slider--content'
        // const SliderImageClass = '.js-event__slider--images'
        // const SliderContentNav = document.querySelector(SliderContentClass + ' .swiper--nav')
        // const slides = document.querySelectorAll(SliderImageClass + ' .swiper-slide');
        // if(slides.length > 1){

        //     const EventImageSlider = new Swiper(SliderImageClass, {
        //         effect:'fade',
        //         speed:1500,
        //         easing: "easeInOutExpo",
        //         loop : true
        //     });
        //     const EventContentSlider = new Swiper(SliderContentClass, {
        //         effect:'slide',
        //         navigation:  {
        //             nextEl: SliderContentClass + ' .swiper-button-next',
        //             prevEl: SliderContentClass + ' .swiper-button-prev',
        //         },
                
        //         easing: "easeOutExpo",
        //         speed:1000,
        //         loop : true,
        //         on: {
        //             init: function () {
        //                 SliderContentNav.innerText = 1 + '/' + slides.length
        //             },
        //             slideChange: function () {
        //                 SliderContentNav.innerText = (EventContentSlider.realIndex + 1) + '/' + slides.length
        //             },
        //         },
        //     });

        //     EventImageSlider.controller.control = EventContentSlider;
        //     EventContentSlider.controller.control = EventImageSlider;
        //     EventContentSlider
        // }
    }
}